import { SerializedElementNode, SerializedLexicalNode, SerializedTextNode } from 'lexical';

export function recursiveLexicalToHtml(lexical: any): string[] {
  const hasLinkChildren = lexical?.children?.some((child: SerializedLexicalNode) => child.type === 'link');
  const hasTextChildren = lexical?.children?.some((child: SerializedLexicalNode) => child.type === 'text');

  if (hasLinkChildren || hasTextChildren) {
    const childrenText = lexical.children.flatMap((child: SerializedLexicalNode) => {
      if (child.type === 'text') { return [(child as SerializedTextNode).text]; }
      if (child.type === 'link') {
        return (child as SerializedElementNode<SerializedLexicalNode>).children.flatMap((grandChild) => {
          if (grandChild.type === 'text') { return [(grandChild as SerializedTextNode).text]; }
          return [];
        });
      }
      return [];
    });
    return [childrenText.join('')];
  }
  if (!lexical.children) { return []; }
  return lexical.children.flatMap((child: SerializedLexicalNode) => recursiveLexicalToHtml(child));
}

export default function lexicalToString(lexical: string): string[] {
  const parsedLexical = JSON.parse(lexical);
  return recursiveLexicalToHtml(parsedLexical.root);
}
